module.exports = __webpack_public_path__ + "img/product-xjg-3360.0947d573.png";